<template>
	<div>
		<div class="title-with-right-button-area">
			<div class="title">
				<h1 v-text="isCompany ? '회원정보 상세' : '기업정보 상세'">기업정보 상세</h1>
			</div>
			<div class="right-btn">
				<button class="lineBtn back" @click="$router.go(-1)">뒤로가기</button>
			</div>
		</div>

		<section class="twin-container company" v-if="!isCompany">
			<div class="mybusiness-company-detail-area">
				<article class="company-info">
					<div class="sub-title">
						<h4>회사정보</h4>
					</div>
					<div class="block half">
						<label>새싹기업명</label>
						<div class="col-company-contents">{{ apiData.companyNmKor }}</div>
					</div>
					<div class="block half">
						<label>아이디</label>
						<div class="col-company-contents">{{ apiData.userId }}</div>
					</div>
					<div class="block half">
						<label>소속TP</label>
						<div class="col-company-contents">{{ apiData.businessTpNm || '-' }}</div>
					</div>
					<div class="block half">
						<label>대표자성명</label>
						<div class="col-company-contents">{{ apiData.ceoNmKor }}</div>
					</div>
					<div class="block half">
						<label>대표전화번호</label>
						<div class="col-company-contents">{{ apiData.companyLandline }}</div>
					</div>
					<div class="block half">
						<label>대표이메일</label>
						<div class="col-company-contents">{{ apiData.ceoEmail || '-' }}</div>
					</div>
					<div class="block half">
						<label>FAX</label>
						<div class="col-company-contents">{{ apiData.fax || '-' }}</div>
					</div>
					<div class="block half">
						<label>설립연도</label>
						<div class="col-company-contents">{{ apiData.foundYear }}</div>
					</div>
					<div class="block half">
						<label>사업자등록번호</label>
						<div class="col-company-contents">{{ apiData.registrationNo }}</div>
					</div>
					<div class="block half">
						<label>업종</label>
						<div class="col-company-contents">{{ apiData.businessTypeNm || '-' }}</div>
					</div>
					<div class="block half">
						<label>세부품목</label>
						<div class="col-company-contents">{{ apiData.mainGoods || '-' }}</div>
					</div>
					<div class="block half">
						<label>수출희망품목</label>
						<div class="col-company-contents">{{ apiData.exportProduct || '-' }}</div>
					</div>
					<div class="block">
						<label>우편번호</label>
						<div class="col-company-contents">{{ apiData.postNo || '-' }}</div>
					</div>
					<div class="block">
						<label>주소</label>
						<div class="col-company-contents">{{ apiData.companyAddress }}</div>
					</div>
					<div class="block">
						<label>홈페이지</label>
						<div class="col-company-contents">{{ apiData.website }}</div>
					</div>
					<div class="block">
						<label>회사소개</label>
						<div class="col-company-contents"><textarea name="introCompany" v-model="apiData.introCompany" readonly disabled /></div>
					</div>
				</article>

				<article class="company-info">
					<div class="sub-title">
						<h4>담당자정보</h4>
					</div>
					<div class="block half">
						<label>성명</label>
						<div class="col-company-contents">{{ apiData.dutyNmKor }}</div>
					</div>
					<div class="block half">
						<label>연락처</label>
						<div class="col-company-contents">{{ apiData.dutyMobile }}</div>
					</div>
					<div class="block half">
						<label>이메일</label>
						<div class="col-company-contents">{{ apiData.dutyEmail }}</div>
					</div>
					<div class="block half">
						<label>일반전화</label>
						<div class="col-company-contents">{{ apiData.dutyLandline }}</div>
					</div>
				</article>
			</div>
		</section>

		<section class="twin-container company" v-if="isCompany">
			<div class="mybusiness-company-detail-area">
				<article class="company-info">
					<div class="sub-title">
						<h4>회원정보</h4>
					</div>
					<div class="block half">
						<label>회원명(국문)</label>
						<div class="col-company-contents">{{ apiData.userNmKor || '-' }}</div>
					</div>
					<div class="block half">
						<label>회원명(영문)</label>
						<div class="col-company-contents">{{ apiData.userNmEng || '-' }}</div>
					</div>
					<div class="block half">
						<label>국가 | 지회</label>
						<div class="col-company-contents">{{ apiData.countryNm + ' | ' + apiData.regionNm }}</div>
					</div>
					<div class="block half">
						<label>회원구분</label>
						<div class="col-company-contents">{{ apiData.userGrd || '-' }}</div>
					</div>
					<div class="block half">
						<label>이메일</label>
						<div class="col-company-contents">{{ apiData.userEmail || '-' }}</div>
					</div>
					<div class="block half">
						<label>휴대폰번호</label>
						<div class="col-company-contents">{{ apiData.userLandline || '-' }}</div>
					</div>
					<div class="block half">
						<label>생년월일</label>
						<div class="col-company-contents">{{ apiData.birthDate || '-' }}</div>
					</div>
					<div class="block half">
						<label>카톡아이디</label>
						<div class="col-company-contents">{{ apiData.kakaoId || '-' }}</div>
					</div>
				</article>

				<article class="company-info">
					<div class="sub-title">
						<h4>회사정보</h4>
					</div>
					<div class="block half">
						<label>회사명(국문)</label>
						<div class="col-company-contents">{{ apiData.companyNmKor || '-' }}</div>
					</div>
					<div class="block half">
						<label>회사명(영문)</label>
						<div class="col-company-contents">{{ apiData.companyNmEng || '-' }}</div>
					</div>
					<div class="block half">
						<label>업종</label>
						<div class="col-company-contents">{{ apiData.businessTypeNm || '-' }}</div>
					</div>
					<div class="block half">
						<label>세부품목</label>
						<div class="col-company-contents">{{ apiData.mainGoods || '-' }}</div>
					</div>
					<div class="block">
						<label>우편번호</label>
						<div class="col-company-contents">{{ apiData.postNo || '-' }}</div>
					</div>
					<div class="block">
						<label>주소</label>
						<div class="col-company-contents">{{ apiData.address || '-' }}</div>
					</div>
					<div class="block">
						<label>홈페이지</label>
						<div class="col-company-contents">{{ apiData.website || '-' }}</div>
					</div>
					<div class="block">
						<label>회사소개</label>
						<div class="col-company-contents"><textarea name="introCompany" v-model="apiData.introCompany" readonly disabled /></div>
					</div>
				</article>
			</div>
		</section>
	</div>
</template>

<script>
import CONST from '@/constants';

export default {
	title: '내비즈니스 회사상세',
	name: 'MybusnessCompany',
	props: ['seqNo'],
	data: function() {
		return {
			CONST,
			loginMember: null,
			select: 1,
			apiData: [],
			productList: [],
			exportProductYn: 'N',
			historyCdRowData: [],
			serviceCdRowData: [],
			participationCdRowData: [],
			stateCdList: [],
			serviceCodeList: [],
			promoFile: [],
		};
	},
	created() {},
	mounted() {
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'BIZ');
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		// let serviceCodeList = this.$device.loadLocalData('SERVICE_LIST');
		// if (serviceCodeList) this.serviceCodeList = JSON.parse(serviceCodeList);

		if (!this.isCompany) {
			this.getCompanyDetail();
		} else {
			this.getOktaUserDetail();
		}
		// this.getStateCdList();
	},
	computed: {
		isCompany: function() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
	},
	methods: {
		getOktaUserDetail: function() {
			this.apiData = [];
			let formData = new FormData();
			formData.append('seqNo', this.seqNo);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/mypage/getOktaUserDetail.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.apiData = res.data.data;
						// console.log(this.apiData);
						// this.historyCdRowData = JSON.parse(this.apiData.historyCd);
						// this.participationCdRowData = JSON.parse(this.apiData.participationCd);
						// this.serviceCdRowData = JSON.parse(this.apiData.serviceCd);
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		getCompanyDetail: function() {
			this.apiData = [];
			let formData = new FormData();
			formData.append('seqNo', this.seqNo);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/mypage/getCompanyDetail.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.apiData = res.data.data;
						// let registrationNo = this.apiData.registrationNo;
						// this.apiData.registrationNo = registrationNo.toString().replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
						// this.promoFile = JSON.parse(this.apiData.promoFile);
						// console.log(this.promoFile);
						// this.getCompanyItemList();
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		// getCompanyItemList: function() {
		// 	let formData = new FormData();
		// 	formData.append('extraNo', this.apiData.extraNo);
		// 	this.$apiClient
		// 		.getInstance()
		// 		.post(this.$apiClient.getApiServer() + '/api/mypage/getCompanyItemList.do', formData)
		// 		.then(res => {
		// 			if (res.data.resultCode === 0) {
		// 				if (res.data.data.length > 0) this.exportProductYn = 'Y';
		// 				if (res.data.data.length > 0) this.productList = res.data.data;
		// 			} else {
		// 				window.alert(res.data.resultMsg);
		// 			}
		// 		})
		// 		.catch(e => console.error(e));
		// },
		// getStateCdList: function() {
		// 	this.stateCdList = [];
		// 	let formData = new FormData();
		// 	formData.append('parentCodeCd', 'LOCAL_COMPANY_STATE');
		// 	this.$apiClient
		// 		.getInstance()
		// 		.post(this.$apiClient.getApiServer() + '/api/common/getMngCodeList.do', formData)
		// 		.then(res => {
		// 			if (res.data.resultCode === 0) {
		// 				this.stateCdList = res.data.data;
		// 			} else {
		// 				window.alert(res.data.resultMsg);
		// 			}
		// 		})
		// 		.catch(e => console.error(e));
		// },
	},
};
</script>

<style scoped></style>
